module.exports = __webpack_public_path__ + "media/fr_ca_s1_Emanuel.284f0a94.mp3";